import { jsx as o } from "react/jsx-runtime";
import { Box as x } from "@chakra-ui/react";
import { useReducedMotion as y, motion as n } from "framer-motion";
import { useRef as I, useMemo as S, useState as A } from "react";
import { useInlineDrawerKeydown as M } from "./use-drawer-key-down.js";
import { ThemeShadowVariable as R, ThemeColorVariable as s } from "../../theme/theme-types.js";
const d = 0.3;
function N({
  children: u,
  isOpen: e,
  onClose: l,
  closeOnEsc: c = !0,
  size: r = "xs",
  zIndex: m = 1,
  ...h
}) {
  const f = I(null);
  M({ isOpen: e, onClose: l, closeOnEsc: c });
  const w = S(() => {
    switch (r) {
      case "xs":
        return 320;
      case "sm":
        return 448;
      case "md":
        return 560;
      case "lg":
        return 672;
      case "xl":
        return 896;
      default:
        return 320;
    }
  }, [r]), [p, i] = A(!e), a = y();
  let t;
  return e ? t = a ? { opacity: 1 } : { width: w } : t = a ? { opacity: 0 } : { width: 0 }, /* @__PURE__ */ o(
    n.aside,
    {
      ref: f,
      hidden: p,
      initial: !1,
      onAnimationStart: () => i(!1),
      onAnimationComplete: () => i(!e),
      animate: t,
      transition: {
        duration: d,
        ease: "easeInOut"
      },
      style: {
        backgroundColor: s.Surface,
        color: s.OnSurface,
        overflow: "hidden",
        boxShadow: R.Medium,
        height: "100dvh",
        top: "0",
        zIndex: m
      },
      children: /* @__PURE__ */ o(
        n.div,
        {
          initial: { opacity: 0 },
          animate: { opacity: e ? 1 : 0 },
          exit: { opacity: 0 },
          transition: { duration: d, ease: "easeInOut" },
          style: { height: "100%", width: "100%" },
          children: /* @__PURE__ */ o(x, { h: "100%", w: "100%", overflowY: "auto", ...h, children: u })
        }
      )
    }
  );
}
export {
  N as InlineDrawer
};
